export default __webpack_public_path__ + "static/media/planet-earth.4d12af96.svg";